import React from 'react';
import { useTranslation } from 'react-i18next';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();
  const title = t('home.hero_title');
  const highlight = t('home.hero_highlight');
  const beforeHighlight = title.replace(highlight, '').trim();

  return (
    <section className="hp-hero">
      <div className="hp-container">
        <div className="hp-hero-content">
          <h1>
            {beforeHighlight} <span className="text-highlight">{highlight}</span>
          </h1>
          <p>{t('home.hero_subtitle')}</p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
